import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { NavLink } from 'react-router-dom';
import { intlShape } from '../components/base/IntlProviderWrapper';
import { Button, Icons } from '../components/base/BootstrapComponents';
import VehicleRegistrationPlate from '../components/base/VehicleRegistrationPlate/VehicleRegistrationPlate';
import Dropdown from '../components/base/Dropdown/Dropdown';

export function HostNameAndStatusFormatter({ item, isComponentBase }) {
  const anchorElement = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const fromParkingZoneName = item?.from_parking_zone?.name;
  const toParkingZoneName = item?.to_parking_zone?.name;
  const hasParkingZonePath = item?.type !== 'payment_terminal' && (fromParkingZoneName || toParkingZoneName);

  return (
    <div className="host">
      {/* <div className="host-assembly">
        { isComponentBase ? (
          <div className="working-state-helper">
            <Dropdown
              usePortal
              customControl
              customOpen={isOpen}
              customHandleClose={() => { setOpen(false); }}
            >
              <Dropdown.Toggle>
                <div
                  className={classNames('tooltip-content')}
                  ref={anchorElement}
                >
                  <div className="host-assembly-icon" ref={anchorElement}>
                    <Icons width={20} height={20} customIcon icon="assembly" className="button-icons" />
                    <div className="field-click-ext" onClick={e => { e.stopPropagation(); setOpen(true); }} />
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu
                className={classNames('portal-tooltip-wrapper wsh-portal-tooltip-wrapper')}
                anchorElement={anchorElement}
                classNamePortal="portal-tooltip wsh-portal"
                useResizeContent={false}
              >
                <div
                  className="portal-tooltip-popup"
                >
                  <div className="wsh-info-tooltip">
                    <div className="wsh-info-title">
                      Компонентная база
                      <Icons icon="close" customIcon className="close" onClick={e => { e.stopPropagation(); setOpen(false); }} />
                    </div>
                    <table className="wsh-info-table">
                      <tbody>
                        {item.components.length && item.components.map((item, key) => (
                          <tr className="wsh-info-table-row" key={key}>
                            <td className="wsh-info-table-cell wsh-key">{item.type_label}</td>
                            <td className="wsh-info-table-cell wsh-value">{item.description || 'Нет данных'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : null }
      </div> */}
      <span className="host-name">
        <div className={classNames('host-status-circle', { online: item.is_online })} />
        {item.name}
      </span>
      { hasParkingZonePath ? (
        <div className="host-path-type">
          <span className="host-type">{fromParkingZoneName || 'Улица'}</span>
          <Icons width={17} height={6} customIcon icon="arrow_path" className="button-icons" />
          <span className="host-type">{toParkingZoneName || 'Улица'}</span>
        </div>
      ) : null }
    </div>
  );
}

export function EquipmentFormatter(components = []) {
  const errorLevelPriority = {
    ok: 0,
    warning: 1,
    error: 2,
  };
  const uniqueComponents = Array.from((components || []).reduce((result, component) => {
    const previousComponent = result.get(component.type);

    if (!previousComponent) {
      result.set(component.type, component);
      return result;
    }

    const previousPriority = errorLevelPriority[previousComponent.error_level] || 0;
    const currentPriority = errorLevelPriority[component.error_level] || 0;

    if (currentPriority > previousPriority) {
      result.set(component.type, component);
    }

    return result;
  }, new Map()).values());

  return (
    <div className="equipments-group">
      {uniqueComponents.map(icon => (
        <div className="equipments-group-item" key={icon.id || icon.type}>
          <Icons width={32} height={32} customIcon icon={icon.type} className="button-icons" />
          <div className="equipments-group-item-status">
            { icon.error_level === 'ok' ? null : <Icons width={17} height={17} customIcon icon={icon.error_level === 'error' ? 'error-circle' : 'warning-circle'} className="button-icons" />}
          </div>
        </div>
      ))}
    </div>
  );
}

const HTTP_EVENT_LABELS = [
  {
    method: 'POST',
    path: /^\/api\/proxy\/report\/v1\/reports\/?$/,
    label: 'Запустил формирование отчета',
  },
  {
    method: 'GET',
    path: /^\/api\/proxy\/report\/v1\/reports\/?$/,
    label: 'Просмотрел список отчетов',
  },
  {
    method: 'GET',
    path: /^\/api\/proxy\/report\/v1\/reports\/[^/]+\/download\/?$/,
    label: 'Скачал отчет',
  },
];

const HTTP_METHOD_LABELS = {
  DELETE: 'Удалил',
  GET: 'Просмотрел',
  PATCH: 'Отредактировал',
  POST: 'Создал',
  PUT: 'Отредактировал',
};

const HTTP_RESOURCE_LABELS = [
  { path: /\/reports(?:\/|$)/, label: 'отчет' },
  { path: /\/sessions(?:\/|$)/, label: 'сессию' },
  { path: /\/payments(?:\/|$)/, label: 'платеж' },
  { path: /\/subscriptions(?:\/|$)/, label: 'абонемент' },
  { path: /\/clients(?:\/|$)/, label: 'клиента' },
  { path: /\/hosts(?:\/|$)/, label: 'хост' },
];

export const readableEventDescription = value => {
  if (!value) {
    return '';
  }

  const description = String(value).trim();
  const httpEvent = description.match(/^(GET|POST|PATCH|PUT|DELETE)\s+([^?\s]+)/i);

  if (!httpEvent) {
    return description;
  }

  const method = httpEvent[1].toUpperCase();
  const path = httpEvent[2];
  const knownEvent = HTTP_EVENT_LABELS.find(event => (
    event.method === method && event.path.test(path)
  ));

  if (knownEvent) {
    return knownEvent.label;
  }

  const resource = HTTP_RESOURCE_LABELS.find(item => item.path.test(path));
  const action = HTTP_METHOD_LABELS[method];

  if (resource && action) {
    return `${action} ${resource.label}`;
  }

  return description;
};

export const eventFormatter = item => (
  <span className="event-formatter">{readableEventDescription(item)}</span>
);

export const hostStatusFormatter = status => (
  <div className={classNames('host-status-formatter', { isError: status === 'error' }, { isOff: status === 'off' })}>
    { status }
  </div>
);

export const historyStatusFormatter = status => {
  const {
    formatMessage,
  } = intlShape;
  return (
    <div className="history-status-formatter">
      <div
        className={classNames('history-status-formatter-info', { isError: status === 'error' }, { isWait: status === 'canceled' })}
      >
        {formatMessage({ id: `history.status.formatter.${status}`, defaultMessage: 'Не известно' })}
      </div>
    </div>
  );
};

export const visualFormatter = item => {
  const visualIcon = [
    { value: 'barrier_closed_no_car', icon: 'radar-state-2' },
    { value: 'barrier_closed_car_present', icon: 'radar-state-3' },
    { value: 'barrier_closed_car_departed', icon: 'radar-state-4' },
    { value: 'barrier_opened_no_car', icon: 'radar-state-7' },
    { value: 'barrier_opened_car_present', icon: 'radar-state-5' },
    { value: 'barrier_opened_car_passed', icon: 'radar-state-1' },
    { value: 'barrier_opened_car_departed', icon: 'radar-state-8' },
    { value: 'unavailable', icon: 'radar-state-6' },
  ];
  const resutlt = visualIcon.find(e => e.value === item) || 0;

  return (
    <div className="visual-park">
      { resutlt ? <Icons width={137} height={104} customIcon icon={resutlt.icon} className="button-icons" /> : null }
    </div>
  );
};

export const vehicleRegistrationPlateFormatter = item => (<VehicleRegistrationPlate item={item} />);

export const vehicleRegistrationPlateTextFormatter = item => (
  <div>
    {item.lpn}
  </div>
);

export const paymentMethodFormatter = (methodLabel, payment = {}) => {
  if (methodLabel) {
    return methodLabel;
  }

  if (payment?.method === 'epp_online') {
    return 'Оплата через мобильное приложение ЕПП';
  }

  return payment?.method || methodLabel;
};

export const logFormatter = (log, item) => (
  <div className="log">
    {item && item.created_at ? <span className="log-time">{dateOrDateTimeFormatter(item.created_at)}</span> : null}
    <span className="log-data">{log || ''}</span>
    {/* { item.variant === 1 ? <span className="log-amount">Сумма: {amount}</span> : null } */}
  </div>
);

export const controlBoxFormatter = item => (
  <div className="control-box-formatter">
    {item.map(icon => (
      <div className="control-box-button" key={icon} onClick={e => e.stopPropagation()}>
        <Icons width={28} height={28} customIcon icon={icon} className="button-icons" />
        <div className="expanded-click-zone" onClick={e => { e.stopPropagation(); }} />
      </div>
    ))}
  </div>
);

export const optionClassFormatter = item => {
  let status = item;
  if (typeof item === 'object') {
    status = item.value;
  }
  if (typeof item !== 'undefined') {
    if (+status === 1) {
      return 'good-state';
    }
    if (+status === 0) {
      return 'warning-state';
    }
    if (+status === -1) {
      return 'error-state';
    }
  }
  return 'unknown-state';
};

export const hostNameFormatter = item => (
  <span className="host-name-formatter">{item}</span>
);

export const sessionNumberFormatter = e => {
  const onClick = event => {
    window.open(`/session-log/?session_id=${e}`, '_blank');
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <span className="menu-link" onClick={onClick}>
      <span className="session-number-formatter">{e}</span>
    </span>
  );
};

export const clientIdFormatter = e => {
  const onClick = event => {
    window.open(`/clients/?client_id=${e}`, '_blank');
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <span className="menu-link" onClick={onClick}>
      <span className="session-number-formatter">{e}</span>
    </span>
  );
};

export const clientTypeFormatter = item => (
  <div className="client-type-formatter">
    <div className="client-type-formatter-box">
      {item}
    </div>
  </div>
);

export const clientStatusFormatter = item => (
  <div className={classNames('client-status-formatter')}>
    <div className={classNames('client-status-formatter-box', { warning: item === 'active_outside', error: item === 'blocked' })}>
      { item === 'active_outside' ? 'Активен, вне территории' : item === 'blocked' ? 'Заблокирован' : 'Активен, на территории' }
    </div>
  </div>
);

export const serviceStatusFormatter = item => (
  <div className={classNames('service-status-formatter', { warning: item === 2, error: item === -1 })}>
    <div className={classNames('service-status-formatter-box', { warning: item === 2, error: item === -1 })}>
      { item === 1 ? 'Активен' : item === -1 ? 'Деактивирован' : 'Стоп' }
    </div>
  </div>
);

const sessionStatusView = {
  in_progress: { label: 'Активна', className: 'sucssesful' },
  complete: { label: 'Завершена', className: '' },
  canceled: { label: 'Отменена', className: 'canceled' },
  ACTIVE: { label: 'Активна', className: 'sucssesful' },
  FINISHED: { label: 'Завершена', className: '' },
  CANCELLED: { label: 'Отменена', className: 'canceled' },
};

const getSessionStatusValue = item => {
  if (item && typeof item === 'object') {
    if (typeof item.value !== 'undefined' && item.value !== null && String(item.value).length) {
      return item.value;
    }

    if (typeof item.name === 'string') {
      return item.name;
    }

    if (typeof item.label === 'string') {
      return item.label;
    }

    if (typeof item.nameId === 'string') {
      return item.nameId;
    }
  }

  return item;
};

export const sessionStatusFormatter = item => {
  const currentValue = getSessionStatusValue(item);
  const currentStatus = sessionStatusView[currentValue]
    || { label: currentValue || 'Неизвестно', className: '' };

  return (
    <div className="session-status-formatter">
      <div className={classNames('session-status-formatter-box', currentStatus.className)}>
        {currentStatus.label}
      </div>
    </div>
  );
};

export const sessionStatusToCopy = item => {
  const currentValue = getSessionStatusValue(item);
  return sessionStatusView[currentValue]?.label || currentValue || '';
};
const badgeValueFormatter = value => (
  <div className="session-status-formatter">
    <div className={classNames('session-status-formatter-box', 'session-info-badge-box')}>
      {value || 'Неизвестно'}
    </div>
  </div>
);

export const sessionTypeFormatter = item => badgeValueFormatter(item);

export const clientIdentifierTypeFormatter = item => badgeValueFormatter(item);

export const clientTypeInSessionFormatter = item => {
  const label = item?.type_label || item?.entry_identifier_label || '';
  return badgeValueFormatter(label);
};

export const paymentAmountFormatter = value => {
  if (value === null || typeof value === 'undefined' || value === '') {
    return '';
  }

  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return value;
  }

  const formattedAmount = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount / 100);

  return `${formattedAmount} ₽`;
};

export const statusFormatter = status => (
  <div>
    { status === 'ok' ? <Icons width={24} height={24} customIcon icon="successful" className="button-icons" /> : <Icons width={24} height={24} customIcon icon={status === 'error' ? 'error' : 'warning'} className="button-icons" />}
  </div>
);

export const statusNotificationFormatter = status => (
  <div className={classNames('status-notification-formatter', { warning: status === 'warning', error: status === 'error' })}>
    { status === 'ok' ? <Icons width={20} height={20} customIcon icon="successful" className="button-icons" /> : <Icons width={20} height={20} customIcon icon={status === 'error' ? 'error' : 'warning'} className="button-icons" />}
    <span className="status-notification-formatter-text"> { status === 'ok' ? 'Выполнено' : status === 'warning' ? 'Предупреждение' : 'Ошибка'}</span>
  </div>
);

export const dateFormatter = a => {
  if (!a) {
    return '';
  }
  if (typeof a === 'string') {
    return a;
  }

  const tz = window.localStorage.getItem('USER_TIME_ZONE') || moment.tz.guess();
  const d = moment.tz(a, tz);
  return d ? d.format('DD.MM.YY') : null;
};

export const dateTimeFormatter = a => {
  if (!a) {
    return '';
  }
  const tz = window.localStorage.getItem('USER_TIME_ZONE') || moment.tz.guess();
  const d = moment.tz(a, tz);
  return d ? d.format('DD.MM.YY HH:mm') : null;
};

export function dateOrDateTimeFormatter(date, onlyHour = false, onlyDate = false) {
  if (!date) {
    return '';
  }
  const tz = window.localStorage.getItem('USER_TIME_ZONE') || moment.tz.guess();
  const currentDay = moment.tz(tz).date();
  const d = moment.tz(date, tz);
  const dateDay = d.date();
  if (onlyHour) {
    return d ? d.format('HH:mm') : null;
  }
  if (onlyDate) {
    return d ? d.format('DD.MM.YY') : null;
  }
  return d ? d.format(dateDay === currentDay ? 'HH:mm' : 'DD.MM.YY HH:mm') : null;
}

export function MoreFormatter(isDisable) {
  return !isDisable ? <Icons customIcon icon="dot" className="more-vert" /> : null;
}

export const enumFormatter = (name, def) => {
  const { formatMessage } = intlShape;
  return formatMessage({ id: name, defaultMessage: typeof def !== 'undefined' ? def : name });
};
